/**
 * UI控件库 
 * @module UI
 */
;(function (ui,$) {
  /**
   * <h3>侧滑列表</h3>
   * <a href="../../ui_controls/bui.listview.html" target="_blank">demo</a>
   * <p>有左右删除菜单,基于sidebar控件,可以通过menu动态渲染,也可以写好自定义结构,手动渲染</p>
   * {{#crossLink "bui.listview/option"}}{{/crossLink}}: 获取设置参数 <br>
   * {{#crossLink "bui.listview/widget"}}{{/crossLink}}: 获取依赖控件 <br>
   *  @namespace bui
   *  @class listview
   *  @constructor 
   *  @param {object} option  
   *  @param {string} option.id [控件id]  
   *  @param {array} [option.data] [点击触发侧滑的按钮 例如:[{ "text": "修改", "classname":"btn-blue"}] ]  
   *  @param {string} [option.data.text] [菜单的文本]  
   *  @param {string} [option.data.classname] [菜单的样式]  
   *  @param {string} [option.handle] [触发的区域,默认是.bui-btn ]  
   *  @param {number} [option.width] [默认宽度100]   
   *  @param {number} [option.height] [ 菜单的高度 0为自适应 ]  
   *  @param {string} [option.position] [ 菜单侧滑的方向 right | left ]  
   *  @param {boolean} [option.mask] [ 遮罩 true ]  
   *  @param {boolean} [option.delay] [ 延迟触发,配合distance,用于控件冲突 ]  
   *  @param {number} [option.distance] [ 默认80, 拖拽大于distance才会生效,配合delay可以防止listview又有上下其它事件 ]  
   *  @param {function} [option.callback] [ 点击的回调 ]  
   *  @example
   *   html:
   *
          <ul id="listview" class="bui-listview">
                <li>
                    <div class="bui-btn">
                        菜单
                    </div>
                </li>
            </ul>
   *      
   *   js: 
   *   
        // 初始化
        var uiListview = bui.listview({ 
                id: "#listview",
                data: [{ "text": "修改", "classname":"btn-blue"},
                        { "text": "删除", "classname":"btn-red"}],
                callback: function (e,ui) {
                    var index = $(this).index();
                        if( index == 1 ){
                            //do something
                        }
                        ui.close();
                }
            });
   *
   *
   */
    ui.listview = function(option){

    	var config = {
            id: "",                
            data:[],                
            handle:".bui-btn",     
            width: 200,            
            position:"right",
            mask: true,      
            delay: false,           
            distance: 80,           
            callback: null,
            autoTrigger: false,
            maxDistance: 280,
            onLoad: null
        };

        //方法
        var module = {
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(true,{}, config, ui.config.listview, option );

        var $id,
            el,
            $menu,
            $children,
            $handle,
            direction,
            distance,
            winWidth;

        //初始化
        init(param);

        function init (option) {
            option = option || param;
            
            if( option.id ){
                $id = ui.obj(option.id);
            }else{
                ui.hint("listview id不能为空");
                return;
            }
            //option获取新参数使用
            param = module.config = option;

            // 屏幕的宽度
            winWidth = document.documentElement.clientWidth; 

            direction = option.position,
            distance = option.distance,
            //列表的li
            $children = $id.children();

            //初始化显示
            display(option);

            return this;

        }

        //渲染结构
        function display (option) {
            $children.css({
                "position":"relative",
                "overflow":"hidden"
            });

            //if( option.data.length ){

                $children.each(function (i,el) {
                    //不动态渲染菜单
                    var status = $(el).attr("status");

                    if( !status ){

                        //渲染按钮模板
                    var html = template( option );
                        $(el).append(html);

                        $(el).attr("status","1");
                    }
                    
                    //找到对应的边栏菜单id
                    var $sideMenu = $(el).children(".bui-listview-menu"),
                        //如果已经设置status,则取菜单的宽度
                        sideWidth = status ? $sideMenu.width(): option.width,
                        sideId = ui.guid(); //$sideMenu.attr("id");
                        $sideMenu.attr("id",sideId);
                    //按钮
                    $handle = $(el).children( option.handle );

                    var menuHeight = $(el).height() ;
                    
                    //有菜单才做渲染
                    if( $sideMenu.length ){

                        //引用边栏控件
                        var uiSidebar = ui.sidebar({
                            id: sideId,
                            handle: $handle,
                            width: sideWidth,
                            height: menuHeight,
                            position: direction,
                            fullHeight:false,
                            mask: option.mask,
                            delay: option.delay,
                            distance: distance,
                            autoTrigger: option.autoTrigger,
                            maxDistance: option.maxDistance,
                            onLoad: option.onLoad
                        })

                    }

                    // 所有事情先关闭一次
                    $(document).on("touchstart",function (e) {
                        //如果是激活状态,则先关闭边栏菜单再操作;
                        uiSidebar&&uiSidebar.isActive()&&uiSidebar.close();
                    })

                    option.callback && $sideMenu.off('click.bui','.bui-btn').on('click.bui','.bui-btn',function (e) {

                        option.callback.call(this,e,uiSidebar);

                    })

                })
            //}
        }


        //模板渲染
        function template (option) {

            var html = '';
            var guid = ui.guid();
                
                html += '<div id="'+ guid +'" class="bui-listview-menu">';
                
                $(option.data).each(function (i,el) {
                    html += '    <div class="bui-btn '+el.classname+'">'+el.text+'</div>';
                })
                html += '</div>';

            return html;
        }

        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 ]
         *  @example 
            
            //获取依赖控件
            var uiListviewWidget = uiListview.widget();
            
                
         */
        function widget(name) {
            var control = { };
            return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
             //获取所有参数
            var option = uiListview.option();

            //获取某个参数
            var id = uiListview.option( "id" );

            //修改一个参数
            uiListview.option( "width",120 );

            //修改多个参数
            uiListview.option( {"width":120} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }

        return module;

    };

    return ui;

})( bui || {}, libs );
